<a
  [routerLink]="[]"
  [fragment]="hash | decodeUriComponent"
  [style.padding-left]="'calc(var(--ng-doc-toc-indent) * ' + level + ')'">
  <ng-content></ng-content>
</a>
